import {ChevronRight} from 'lucide-react';
import {Button} from '@repo/ui/button';

interface EditorToolbarProps {
  onClick: () => void;
  disabled: boolean;
  label: string;
  runningLabel: string;
  running: boolean;
  viewUrl?: string;
  hint: string;
}

export function EditorToolbar({
  onClick,
  disabled,
  label,
  runningLabel,
  running,
  viewUrl,
  hint,
}: EditorToolbarProps) {
  return (
    <div className='flex items-center justify-between gap-x-3'>
      <div className='flex items-center gap-3 flex-wrap'>
        <Button
          className='flex flex-1 items-center gap-1.5 px-4 py-2 bg-iq-orange text-white text-sm font-semibold hover:opacity-90 transition-opacity disabled:opacity-50 '
          onClick={onClick}
          disabled={disabled}>
          <ChevronRight className='w-4 h-4' />
          {running ? runningLabel : label}
        </Button>
        {viewUrl && (
          <Button
            asChild
            className='px-5 py-2 flex-1 border border-iq-yellow text-iq-yellow text-sm font-medium rounded-md hover:bg-yellow-50 transition-colors bg-transparent'>
            <a href={viewUrl}>View Question</a>
          </Button>
        )}
      </div>
      <div className='flex items-center gap-3'>
        <span className='text-xs text-iq-grey-medium hidden sm:block'>{hint}</span>
      </div>
    </div>
  );
}
